// src/components/ProtectionPlans.jsx
import React from 'react';
import lossOfIncome from '../assets/lossOfIncome.jpg'
import medicines from '../assets/medicine.jpg'
import food from '../assets/food.jpg'
import travel from '../assets/travel.png'
import accommodation from '../assets/accomodation.png'
import '../ProtectionPlans.css'; // Create and import a CSS file for styles

const ProtectionPlans = () => {
  return (
    <div className="protection-plans">
      <h2>Protection against non medical spends</h2>
      <div className="plans">
        <div className="plan">
          <img src={lossOfIncome} alt="Loss of Income" />
        </div>
        <div className="plan">
          <img src={medicines} alt="Medicines" />
        </div>
        <div className="plan">
          <img src={food} alt="Food" />
        </div>
        <div className="plan">
          <img src={travel} alt="Travel" />
        </div>
        <div className="plan">
          <img src={accommodation} alt="Accommodation" />
        </div>
      </div>
    </div>
  );
};

export default ProtectionPlans;
